import * as Yup from "yup";
import formFieldDistancia from "./formFieldDistancia";

const { descricao, distancia, unidade, qtdLimite } = formFieldDistancia;

const validationDistancia = Yup.object().shape({
  [descricao.name]: Yup.string().required(descricao.errorMsg),
  [distancia.name]: Yup.number().required(distancia.errorMsg),
  [unidade.name]: Yup.string().required(unidade.errorMsg),
  [qtdLimite.name]: Yup.number().min(1).required(qtdLimite.errorMsg),
});

export { validationDistancia };
